<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div>
            <h4>Thêm mới yêu cầu ra ngoài</h4>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <div class="form-card mb-3">
              <el-card class="box-card">
                <div>
                  <el-form
                    :model="mData.dataForm"
                    :rules="mData.validForm"
                    ref="myForm"
                    label-width="160px"
                    label-position="top"
                  >
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Tiêu đề"
                          prop="employee_request.title"
                        >
                          <el-input
                            type="text"
                            v-model="mData.dataForm.employee_request.title"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            ref="title"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Phân loại"
                          prop="employee_request.type"
                        >
                          <el-select
                            disabled
                            clearable
                            filterable
                            v-model="mData.dataForm.employee_request.type"
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listType"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12" v-if="mData.reselectEmployee">
                        <el-form-item
                          label="Nhân viên"
                          prop="employee_request.employee_id"
                        >
                          <el-select
                            filterable
                            v-model="
                              mData.dataForm.employee_request.employee_id
                            "
                            :disabled="!isSelectEmployee"
                            @change="fn_reSelectEmployee"
                          >
                            <el-option
                              v-for="item in filteredRequestEmployees"
                              :key="item.id"
                              :label="fn_setLabelRespectively(item)"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="mData.reselectEmployee">
                      <b-col md="6">
                        <el-form-item label="Chi nhánh">
                          <el-select v-model="requestEmployeeFilter.branch_ids" multiple filterable clearable disabled collapse-tags placeholder="Tất cả chi nhánh" @change="fn_resetEmployeeWhenFilteredOut">
                            <el-option v-for="item in filteredBranchList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item label="Phòng ban">
                          <el-select v-model="requestEmployeeFilter.department_ids" multiple filterable clearable disabled collapse-tags placeholder="Tất cả phòng ban" @change="fn_resetEmployeeWhenFilteredOut">
                            <el-option v-for="item in filteredDepartmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý trực tiếp"
                          prop="employee_request.level2Approval"
                        >
                          <DirectManagerField
                            v-model="
                              mData.dataForm.employee_request.level2Approval
                            "
                            :options="mData.dataDefault.listQuanLyTrucTiep"
                            :label-builder="fn_setLabelRespectively"
                          />
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý nhân sự"
                          prop="employee_request.employeeApproval"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="
                              mData.dataForm.employee_request.employeeApproval
                            "
                          >
                            <el-option
                              v-for="(item, index) in listHrApprove"
                              :key="item.e && item.e.id ? item.e.id : index"
                              :label="
                                item.e &&
                                item.e.administrative_info &&
                                item.e.administrative_info.name &&
                                item.e.administrative_info.name.full_name
                                  ?`${item.e.employee_no ? item.e.employee_no : ''} - ${item.e.administrative_info.name.full_name ? item.e.administrative_info.name.full_name : ''}`
                                  : 'không xác định'
                              "
                              :value="item.e && item.e.id ? item.e.id : ''"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Lý do"
                          prop="detail_request.request_reason_id"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="
                              mData.dataForm.detail_request.request_reason_id
                            "
                          >
                            <el-option
                              v-for="item in mData.dataDefault
                                .listRequestReason"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col v-if="listEmployeeShiftDetail.length > 0">
                        <el-form-item
                          label="Ca làm việc"
                          prop="detail_request.shift_id"
                        >
                          <el-radio-group
                            v-model="mData.dataForm.detail_request.shift_id"
                            @change="fn_changeShift"
                          >
                            <el-radio
                              class="mr-3"
                              v-for="(shift, index) in listEmployeeShiftDetail"
                              :key="index"
                              :label="shift.id"
                              >{{ shift.name }}</el-radio
                            >
                          </el-radio-group>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="6">
                        <el-form-item
                          label="Thời gian từ"
                          prop="detail_request.from_date"
                        >
                          <el-date-picker
                            type="datetime"
                            v-model="mData.dataForm.detail_request.from_date"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            prefix-icon="isax-calendar-1"
                            :clearable="false"
                            :format="'HH:mm dd/MM/yyyy' || 'HH:mm dd-MM-yyyy'"
                            :picker-options="pickerOptionFrom"
                            @change="fn_checkValidDate"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item label="tới" prop="detail_request.to_date">
                          <el-date-picker
                            type="datetime"
                            v-model="mData.dataForm.detail_request.to_date"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            prefix-icon="isax-calendar-1"
                            :clearable="false"
                            :format="'HH:mm dd/MM/yyyy' || 'HH:mm dd-MM-yyyy'"
                            :picker-options="pickerOptionFrom"
                            @change="fn_checkValidDate"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Ghi chú"
                          prop="employee_request.content"
                        >
                          <el-input
                            type="textarea"
                            v-model="mData.dataForm.employee_request.content"
                            :disabled="mData.viewMode == 'detail'"
                            resize="none"
                            :autosize="{ minRows: 3, maxRows: 3 }"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <div class="text-center mt-2">
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        :disabled="!createRequest"
                        class="btn-default"
                        @click="fn_submitForm('create')"
                        >Thêm mới</el-button
                      >
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        class="btn-back"
                        @click="fn_goBack"
                        >Quay lại</el-button
                      >
                    </div>
                  </el-form>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from "../../../../service/MethodService";
import EmployeeRequestApi from "../../../../moduleApi/EmployeeRequestApi";
import EmployeeRequestGoOutApi from "../../../../moduleApi/EmployeeRequestGoOutApi";
import DirectManagerField from "../components/DirectManagerField";
import { dataMixins } from "../../ManageRequests/RequestMixins/dataMixins";
import { fnMixins } from "../../ManageRequests/RequestMixins/fnMixins";
export default {
  components: { DirectManagerField },
  mixins: [dataMixins, fnMixins],
  data() {
    return { typeReq: "GO_OUT" };
  },
  computed: {
    filteredDepartmentList() {
      const employeeId = this.mData.dataForm.employee_request.employee_id;
      if (!employeeId) {
        return (this.mData.dataDefault.listDepartment || []).filter(
          (dept) => dept.company_id === this.currentCompany.id
        );
      }

      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      const departmentIds = [
        ...new Set(
          (this.fn_getActiveJobInfo(selectedEmployee) || [])
            .map((item) => item.department_id)
            .filter(Boolean)
        ),
      ];

      return (this.mData.dataDefault.listDepartment || []).filter((dept) =>
        departmentIds.includes(dept.id)
      );
    },
    filteredBranchList() {
      const employeeId = this.mData.dataForm.employee_request.employee_id;
      if (!employeeId) {
        return (this.mData.dataDefault.listBranch || []).filter(
          (branch) => branch.company_id === this.currentCompany.id
        );
      }

      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      const branchIds = [
        ...new Set(
          (this.fn_getActiveJobInfo(selectedEmployee) || [])
            .map((item) => item.branch_id)
            .filter(Boolean)
        ),
      ];

      return (this.mData.dataDefault.listBranch || []).filter((branch) =>
        branchIds.includes(branch.id)
      );
    },
  },

  methods: {
    async fn_innitDataDefault() {
      await this.fn_getListEmployee();
      await this.fn_getListEmployeeRequestReason(this.typeReq);
      await this.fn_getListEmployeeApprovedQLTT();
    },

    fn_syncRequestOrgFilterByEmployee(employeeId) {
      if (!employeeId) return;
      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId);
      if (!selectedEmployee) return;

      const activeJobs = this.fn_getActiveJobInfo(selectedEmployee);
      this.requestEmployeeFilter.department_ids = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.department_id)
            .filter(Boolean)
        ),
      ];
      this.requestEmployeeFilter.branch_ids = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.branch_id)
            .filter(Boolean)
        ),
      ];

      this.$nextTick(() => {
        this.fn_resetEmployeeWhenFilteredOut();
      });
    },

    async fn_reSelectEmployee() {
      if (!this.mData.dataForm.employee_request.employee_id) {
        return;
      }

      this.fn_syncRequestOrgFilterByEmployee(
        this.mData.dataForm.employee_request.employee_id
      );
      await this.fn_initDataShift();
      this.mData.validForm.employee_request.employee_id = [];
      this.$nextTick(() => {
        if (this.$refs["myForm"]) {
          this.$refs["myForm"].clearValidate("employee_request.employee_id");
        }
      });
    },

    fn_checkValidDate() {
      this.createRequest = true;
      const currentTime = new Date().getTime();
      let goOutTime_from = this.mData.dataForm.detail_request.from_date;
      let goOutTime_to = this.mData.dataForm.detail_request.to_date;
      if (this.mData.dataForm.detail_request.from_date) {
        goOutTime_from = new Date(goOutTime_from).getTime();
      }
      if (this.mData.dataForm.detail_request.to_date) {
        goOutTime_to = new Date(goOutTime_to).getTime();
      }
      if (!this.mData.dataForm.employee_request.employee_id) {
        window.toastr.warning("Vui lòng chọn Nhân viên !");
        if (this.mData.dataForm.detail_request.from_date) {
          this.mData.dataForm.detail_request.from_date = undefined;
        } else if (this.mData.dataForm.detail_request.to_date) {
          this.mData.dataForm.detail_request.to_date = undefined;
        }
      } else if (!this.mData.dataForm.detail_request.shift_id) {
        window.toastr.warning(
          "Vui lòng chọn Ca làm việc trước khi chọn thời gian !"
        );
        if (this.mData.dataForm.detail_request.from_date) {
          this.mData.dataForm.detail_request.from_date = undefined;
        } else if (this.mData.dataForm.detail_request.to_date) {
          this.mData.dataForm.detail_request.to_date = undefined;
        }
      } else {
        if (goOutTime_from && goOutTime_from < currentTime) {
          this.mData.dataForm.detail_request.from_date = undefined;
          window.toastr.warning(
            "Thời gian ra ngoài phải là lớn hơn thời điểm hiện tại !"
          );
        } else if (goOutTime_to && goOutTime_to < currentTime) {
          this.mData.dataForm.detail_request.to_date = undefined;
          window.toastr.warning(
            "Thời gian ra ngoài phải là lớn hơn thời điểm hiện tại !"
          );
        } else if (goOutTime_from && goOutTime_to) {
          if (goOutTime_from >= goOutTime_to) {
            this.mData.dataForm.detail_request.to_date = undefined;
            window.toastr.warning(
              "Mốc 'tới' phải là lớn hơn mốc 'Thời gian từ' !"
            );
          } else {
            if (this.listEmployeeShift) {
              // check nếu thời gian hiện tại có trong thời gian hiệu lực của ca
              const idEmployeeShift = this.fn_checkValidShift(currentTime).shift_id;
              // check thời gian trong chấp nhận của ca trong ngày
              if (idEmployeeShift) {
                this.validTimeCreateReq = false;
                const t = this.mData.dataForm.detail_request.from_date;
                let todayShiftTime = [];
                const flag = this.fn_checkHasShiftAndNumberWordDay(t, todayShiftTime);
                if (flag) {
                  this.fn_checkValidTimeReq(todayShiftTime, t, idEmployeeShift, goOutTime_from, goOutTime_to);
                  if (this.validTimeCreateReq == false) {
                    this.createRequest = false;
                    // this.mData.dataForm.detail_request.to_date = undefined;
                    window.toastr.warning(
                      "Thời gian xin ra ngoài phải trong khoảng từ khi bắt đầu đến khi kết thúc ca trong ngày !"
                    );
                  }
                }
              } else {
                this.mData.dataForm.detail_request.from_date = undefined;
                this.mData.dataForm.detail_request.to_date = undefined;
                window.toastr.warning(
                  "Ca này hiện không hiệu lực để tạo yêu cầu !"
                );
              }
            } else {
              this.createRequest = false;
              window.toastr.warning("Nhân viên không có ca để tạo yêu cầu !");
            }
          }
        }
      }
    },

    fn_checkValidTimeReq(todayShiftTime, t, idEmployeeShift, goOutTime_from, goOutTime_to) {
      if (todayShiftTime && (todayShiftTime.length == 1 && todayShiftTime[0].start_time.hour || todayShiftTime.length == 2 && !todayShiftTime[1].start_time.hour)) {
        const startTimeShift = new Date(t).setHours(
          todayShiftTime[0].start_time.hour,
          todayShiftTime[0].start_time.minute
        );
        const endTimeShift = new Date(t).setHours(
          todayShiftTime[0].end_time.hour,
          todayShiftTime[0].end_time.minute
        );
        // có 1 ca trong ngày
        this.listEmployeeShiftDetail.find((shift) => {
          if (shift.id == idEmployeeShift) {
            const acceptTimeStart = new Date(
              goOutTime_from
            ).setHours(
              shift.acceptance_time_start.hour,
              shift.acceptance_time_start.minute,
              0
            );
            const acceptTimeEnd = new Date(
              goOutTime_from
            ).setHours(
              shift.acceptance_time_end.hour,
              shift.acceptance_time_end.minute,
              0
            );
            if (
              goOutTime_from >= acceptTimeStart &&
              goOutTime_from <= acceptTimeEnd &&
              goOutTime_from >= startTimeShift &&
              goOutTime_from <= endTimeShift &&
              goOutTime_to >= acceptTimeStart &&
              goOutTime_to <= acceptTimeEnd &&
              goOutTime_to > startTimeShift &&
              goOutTime_to <= endTimeShift
            ) {
              this.validTimeCreateReq = true;
            }
          }
          return;
        });
      } else if (todayShiftTime && todayShiftTime.length == 2 && todayShiftTime[1].start_time.hour) {
        // có 2 ca. VD: ca sáng ca chiều
        const startTimeShift1 = new Date(t).setHours(
          todayShiftTime[0].start_time.hour,
          todayShiftTime[0].start_time.minute
        );
        // const endTimeShift1 = new Date(t).setHours(
        //   todayShiftTime[0].end_time.hour,
        //   todayShiftTime[0].end_time.minute
        // );
        // const startTimeShift2 = new Date(t).setHours(
        //   todayShiftTime[1].start_time.hour,
        //   todayShiftTime[1].start_time.minute
        // );
        const endTimeShift2 = new Date(t).setHours(
          todayShiftTime[1].end_time.hour,
          todayShiftTime[1].end_time.minute
        );
        this.listEmployeeShiftDetail.find((shift) => {
          if (shift.id == idEmployeeShift) {
            const acceptTimeStart = new Date(
              goOutTime_from
            ).setHours(
              shift.acceptance_time_start.hour,
              shift.acceptance_time_start.minute,
              0
            );
            const acceptTimeEnd = new Date(
              goOutTime_from
            ).setHours(
              shift.acceptance_time_end.hour,
              shift.acceptance_time_end.minute,
              0
            );
            if (
              (goOutTime_from >= acceptTimeStart &&
                goOutTime_from <= acceptTimeEnd &&
                goOutTime_from >= startTimeShift1 &&
                // goOutTime_from <= endTimeShift1 &&
                goOutTime_to >= acceptTimeStart &&
                goOutTime_to <= acceptTimeEnd &&
                goOutTime_to >= startTimeShift1 &&
              //   goOutTime_to <= endTimeShift1) ||
              // (goOutTime_from >= acceptTimeStart &&
              //   goOutTime_from <= acceptTimeEnd &&
              //   goOutTime_from > startTimeShift2 &&
                goOutTime_from <= endTimeShift2 &&
              //   goOutTime_to >= acceptTimeStart &&
              //   goOutTime_to <= acceptTimeEnd &&
              //   goOutTime_to > startTimeShift2 &&
                goOutTime_to <= endTimeShift2)
            ) {
             this.validTimeCreateReq = true;
            }
          }
          return;
        });
      }
    },

    //Form
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            let listApprovalUser = [];
            listApprovalUser = [
              {
                approval_user_id:
                  this.mData.dataForm.employee_request.level2Approval,
              },
              {
                approval_user_id:
                  this.mData.dataForm.employee_request.employeeApproval,
              },
            ];
            this.mData.dataForm.employee_request.title =
              this.mData.dataForm.employee_request.title.trim();
            this.mData.dataForm.employee_request.content =
              this.mData.dataForm.employee_request.content.trim();
            this.mData.dataForm.employee_request.company_id =
              this.currentCompany.id;
            this.mData.dataForm.employee_request.approval_users =
              listApprovalUser;
            this.mData.dataForm.employee_request.is_sequential = true;
            this.mData.dataForm.employee_request.approval_level = 2;
            let dataEmployeeRequest = this.mData.dataForm.employee_request;
            let dataEmployeeRequestDetail = this.mData.dataForm.detail_request;
            if (type == "create") {
              const res = await EmployeeRequestApi.create(dataEmployeeRequest);
              dataEmployeeRequestDetail.id = res.result;
              await EmployeeRequestGoOutApi.create(dataEmployeeRequestDetail);
              if (
                this.mData.dataDefault.listFeature.includes("FT1001") ||
                this.mData.dataDefault.listFeature.includes("FT1002")
              ) {
                this.$router.push({
                  name: "Admin-ManageRequests-RequestsWaitingForApproval",
                });
              }
              this.fn_resetForm();
              this.listEmployeeShiftDetail = [];
              this.fn_checkHasEmployee();
            }
          } catch (error) {
            console.log("error", error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
  },

  async created() {
    this.mData.dataForm.employee_request.type = "GO_OUT";
    await this.fn_innitDataDefault();
    await this.fn_checkHasEmployee();
    this.fn_syncRequestOrgFilterByEmployee(
      this.mData.dataForm.employee_request.employee_id
    );
  },
  mounted() {
    this.$refs.title.focus();
  },
};
</script>
<style scoped src="../../../../assets/css/layout/Request.css">
</style>
